"use client"

import type { ButtonHTMLAttributes, FunctionComponent, PropsWithChildren } from "react"

import { clsx } from "clsx"

import { Button } from "@jobteaser/spark/components/Button"
import { Menu } from "@jobteaser/spark/components/Icons/Menu"

import { UserAvatar } from "@/modules/dashboard/components/UserAvatar/UserAvatar"

import dropdownMenuStyles from "@/modules/headerFooterFO/Header/styles/DropdownMenuV2.module.css"

type DropdownUserButtonV2Props = PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement> & {
    activeHrefs: string[]
    avatarUrl?: string | null
    strictActiveCheck?: boolean
  }
>

export const DropdownUserButtonV2: FunctionComponent<DropdownUserButtonV2Props> = ({ avatarUrl, ...props }) => {
  return (
    <Button
      {...props}
      className={clsx(dropdownMenuStyles["hdr-DropdownMenu-link"])}
      size="small"
      type="button"
      variant="secondary"
    >
      <UserAvatar className={dropdownMenuStyles["hdr-DropdownMenu-avatar"]} size={32} src={avatarUrl || ""} />
      <Menu className={dropdownMenuStyles["hdr-DropdownMenu-linkMenuIcon"]} size={20} />
    </Button>
  )
}
